/**
 * Created by Alon Yampolski on 19/12/2018.
 */
import { PlaceholderModalLoaderPayload } from '@ispm/layout/classes/placeholder-modal-loader-payload';

export class PanelLoaderPayload extends PlaceholderModalLoaderPayload {
  static builder() {
    return new this(undefined, undefined);
  }
}
